module.exports = __webpack_public_path__ + "static/media/services_professional_services.d9454bf7.jpg";